import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { TicketType } from "@faire/help-center-self-serve/consts";
import { getAllZenDeskTagsInArray } from "@faire/help-center-self-serve/utils/zenDeskTags";
import { getRetailerOrBrandCountry } from "@faire/help-center-utils/serialized-data/getRetailerOrBrandCountry";
import { getRetailerOrBrandToken } from "@faire/help-center-utils/serialized-data/getRetailerOrBrandToken";
import createTicket from "@faire/web-api/api/zendesk/create-ticket/post";
import { ICreateTicketRequest } from "@faire/web-api/com/faire/vendor/zendesk/ICreateTicketRequest";
import { trackCxFoundationsTicketcreated } from "@faire/web-api/events/cxFoundations/actionUnknown/ticketcreated";
import { trackCxFoundationsLoggedOutSubmissionClick } from "@faire/web-api/events/cxFoundations/click/loggedOutSubmission";
import { trackHelpCenterAllTypesOfTicketCreationSubmit } from "@faire/web-api/events/helpCenter/submit/allTypesOfTicketCreation";
import { QueryParameters as SupportQueryParams } from "@faire/web-api/routes/support";
import { useQueryParams } from "@faire/web/ui/hooks/useQueryParams";
import UAParser from "ua-parser-js";
import { useLoggedOutContactUsContextStore } from "./LoggedOutContactUsContextStore";
import { useLoggedOutEmailContextStore } from "./LoggedOutEmailContextStore";
import { useLoggedOutContactUsNavigation } from "./useLoggedOutContactUsNavigation";
import { useLoggedOutIssueType } from "./useLoggedOutIssueType";
import { useLoggedOutUserType } from "./useLoggedOutUserType";
export var useLoggedOutEmailTicket = function useLoggedOutEmailTicket() {
  var _useLoggedOutContactU = useLoggedOutContactUsNavigation(),
    goToNextStep = _useLoggedOutContactU.goToNextStep;
  var _useLoggedOutIssueTyp = useLoggedOutIssueType(),
    issueType = _useLoggedOutIssueTyp.issueType;
  var _useQueryParams = useQueryParams(SupportQueryParams.parse),
    os_version = _useQueryParams.os_version,
    platform = _useQueryParams.platform,
    app_version = _useQueryParams.app_version;
  var _useLoggedOutUserType = useLoggedOutUserType(),
    isKnownUserType = _useLoggedOutUserType.isKnownUserType;
  var _useLoggedOutContactU2 = useLoggedOutContactUsContextStore(["user", "issueL1"]),
    _useLoggedOutContactU3 = _slicedToArray(_useLoggedOutContactU2, 1),
    _useLoggedOutContactU4 = _useLoggedOutContactU3[0],
    user = _useLoggedOutContactU4.user,
    issueL1 = _useLoggedOutContactU4.issueL1;
  var _useLoggedOutEmailCon = useLoggedOutEmailContextStore(["businessName", "contactEmail", "details"]),
    _useLoggedOutEmailCon2 = _slicedToArray(_useLoggedOutEmailCon, 2),
    _useLoggedOutEmailCon3 = _useLoggedOutEmailCon2[0],
    businessName = _useLoggedOutEmailCon3.businessName,
    contactEmail = _useLoggedOutEmailCon3.contactEmail,
    details = _useLoggedOutEmailCon3.details,
    setLoggedOutEmailContextStore = _useLoggedOutEmailCon2[1];
  var isLoggedOutSubmitDisabled = function isLoggedOutSubmitDisabled() {
    return !isKnownUserType || !issueL1 || !contactEmail || !businessName || !details;
  };
  var submitTicket = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(strictLocalize) {
      var _getRetailerOrBrandCo, _getRetailerOrBrandTo, _zdResponse$id, _zdResponse$id2, ua, platformValue, osVersionValue, appVersionValue, ticketCreationPayload, customerToken, zdResponse;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            ua = new UAParser(navigator.userAgent).getResult();
            platformValue = platform !== null && platform !== void 0 ? platform : ua.browser.name;
            osVersionValue = os_version !== null && os_version !== void 0 ? os_version : "".concat(ua.os.name, " ").concat(ua.os.version);
            appVersionValue = app_version !== null && app_version !== void 0 ? app_version : ua.browser.version;
            trackCxFoundationsLoggedOutSubmissionClick();
            ticketCreationPayload = ICreateTicketRequest.build({
              tags: getAllZenDeskTagsInArray((_getRetailerOrBrandCo = getRetailerOrBrandCountry()) !== null && _getRetailerOrBrandCo !== void 0 ? _getRetailerOrBrandCo : "", user !== null && user !== void 0 ? user : "", issueType !== null && issueType !== void 0 ? issueType : ""),
              email: contactEmail,
              name: businessName,
              subject: issueType,
              issue_type: issueType,
              description: details,
              platform: platformValue,
              os_version: osVersionValue,
              app_version: appVersionValue
            });
            customerToken = (_getRetailerOrBrandTo = getRetailerOrBrandToken()) !== null && _getRetailerOrBrandTo !== void 0 ? _getRetailerOrBrandTo : "";
            _context.next = 10;
            return createTicket(ticketCreationPayload);
          case 10:
            zdResponse = _context.sent;
            trackCxFoundationsTicketcreated(((_zdResponse$id = zdResponse.id) !== null && _zdResponse$id !== void 0 ? _zdResponse$id : "").toString(), "", customerToken);
            trackHelpCenterAllTypesOfTicketCreationSubmit("", "", "", contactEmail, "", issueType, details, issueType, TicketType.LOGGED_OUT, ((_zdResponse$id2 = zdResponse.id) !== null && _zdResponse$id2 !== void 0 ? _zdResponse$id2 : "").toString(), "", businessName);
            goToNextStep();
            _context.next = 19;
            break;
          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            setLoggedOutEmailContextStore({
              formErrorMessage: strictLocalize({
                id: "6vUWuh",
                defaultMessage: [{
                  "type": 0,
                  "value": "O seu pedido falhou. Tente novamente."
                }]
              })
            });
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 16]]);
    }));
    return function submitTicket(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    submitTicket: submitTicket,
    isLoggedOutSubmitDisabled: isLoggedOutSubmitDisabled
  };
};